import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["footerLinks", "socialNetworksUrls"];
import { List, Record, fromJS } from 'immutable';
class KnowledgeBaseTranslatedContentRecord extends Record({
  companyWebsiteLink: undefined,
  companyWebsiteLinkText: undefined,
  footerLinks: List(),
  footerMessage: undefined,
  name: undefined,
  socialNetworksUrls: List(),
  supportFormId: undefined,
  supportFormTitle: undefined,
  welcomeMessage: undefined
}) {
  static fromJS(json) {
    const {
        footerLinks = [],
        socialNetworksUrls = []
      } = json,
      rest = _objectWithoutPropertiesLoose(json, _excluded);
    return new KnowledgeBaseTranslatedContentRecord(Object.assign({}, rest, {
      footerLinks: fromJS(footerLinks),
      socialNetworksUrls: fromJS(socialNetworksUrls)
    }));
  }
}
export default KnowledgeBaseTranslatedContentRecord;